module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAEACAIAAAA828FjAAAABGdBTUEAAK/INwWK6QAAABl0RVh0U29mdHdhcmUAQWRvYmUgSW1hZ2VSZWFkeXHJZTwAAAB0SURBVHja7NhBCoAwEATBIYr+/7uBoL4he5CQWuZa92bbk0zvTK7MHgzDMAzDMPwbvufxSJvHPYFhGIZhGIa3woVuhWEYhmEYhtfExyjgdBiGYRiGYXgrXEhPGIZhGIZheElc+B9+7dlhGIZhGIbhrfArwAB9SZjrqKFyJgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// E:/Atlassian/bamboo-home/1/7766019/ESDE-EN172-JOB1/ng5/node_modules/jqwidgets-framework/jqwidgets/styles/images/colorpicker/bar-hue.png
// module id = ../../../../jqwidgets-framework/jqwidgets/styles/images/colorpicker/bar-hue.png
// module chunks = styles